import { Grid, Typography, styled } from "@mui/material";
import styles from "./muhurtham.module.scss";
import Tooltip, {
  type TooltipProps,
  tooltipClasses,
} from "@mui/material/Tooltip";
import { useEffect, useState } from "react";
import { isEmpty, isNil } from "lodash";
import {
  apiRequest,
  catchErrorMessageHandler,
  formatWeekday,
} from "../../../infrastructure/backendService";
import ToastError from "../toast/toastError";
import toast from "react-hot-toast";
import apiPath from "../../../config/apiPaths.json";
import ErrorPopup from "../ErrorPopup";
import constants from "../../../config/constants.json";
import {
  getSortedActivities,
  getTimeWithMeridiem,
} from "../handleTimeChangeSetErrors";
import { CMS_BASE_URL } from '../../../config/apiUrl';

export const CustomTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({}) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: "#22A699",
    boxShadow: "none",
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#22A699",
    fontSize: "14px",
    fontStyle: "normal",
    fontFamily: "Lato",
    boxShadow: "none",
  },
}));

export default function Muhurtham(): JSX.Element {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [thithi, setThithi] = useState<string | null>("");
  const [thithiTime, setThithiTime] = useState<string | null>("");
  const [thithi2, setThithi2] = useState<string | null>("");
  const [thithiTime2, setThithiTime2] = useState<string | null>("");
  const [nakshtram, setNakshtram] = useState<string | null>("");
  const [nakshtramTime, setnakshtramtime] = useState<string | null>("");
  const [nakshtram2, setNakshtram2] = useState<string | null>("");
  const [nakshtramTime2, setnakshtramtime2] = useState<string | null>("");
  const [rahukalam, setrahukalam] = useState<string | null>("");
  const [durmuhurtham, setdurmuhurtham] = useState<string | null>("");
  const [durmuhurtham2, setdurmuhurtham2] = useState<string | null>("");
  const [Samvatsar, setSamvatsar] = useState<string | null>("");
  const [ritu, setRitu] = useState<string | null>("");
  const [masa, setMasa] = useState<string | null>("");
  const [paksha, setPaksha] = useState<string | null>("");
  const [ayanam, setAyanam] = useState<string | null>("");
  const [ayanamTime, setAyanamTime] = useState<string | null>("");
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [breakStartTime, setBreakStartTime] = useState("");
  const [breakEndTime, setBreakEndTime] = useState("");
  const [messageData, setMessageData] = useState([]);
  const [showMsg, setShowMsg] = useState<boolean>(false);

  function formatDate(): string {
    const today = new Date();
    const day = today?.getDate();
    const month = today?.getMonth() + 1;
    const year = today?.getFullYear();

    const formattedDay = day < 10 ? `0${day}` : day;
    const formattedMonth = month < 10 ? `0${month}` : month;

    return `${formattedMonth}/${formattedDay}/${year}`;
  }

  useEffect(() => {
    apiRequest({
      method: "POST",
      endpoint: apiPath.dailyTempleActivity,
      params: {
        scheduleDate: formatDate(),
      },
    })
      .then((res) => {
        const activities = res?.data?.dailyActivities;
        const templeStartTime = getTimeWithMeridiem(activities, "temple opens");
        const templeBreakStartTime = getTimeWithMeridiem(
          activities,
          "temple closes for afternoon break"
        );
        const templeBreakEndTime = getTimeWithMeridiem(
          activities,
          "temple opens for evening services"
        );
        const templeEndTime = getTimeWithMeridiem(activities, "temple closes");
        setStartTime(templeStartTime);
        setEndTime(templeEndTime);
        setBreakStartTime(templeBreakStartTime);
        setBreakEndTime(templeBreakEndTime);
      })
      .catch((err) => {
        console.error(err);
        toast.custom(
          <ErrorPopup
            showMessage={catchErrorMessageHandler(err)}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
      });
  });

  useEffect(() => {
    apiRequest({
      method: "GET",
      endpoint: apiPath.panchangamApi,
      params: {
        scheduleDate: formatDate(),
      },
    })
      .then((res) => {
        console.log(res.data);
        const apiData = res.data;
        setThithi(apiData.thithi1);
        setThithiTime(apiData.thithi1Time);
        setThithi2(apiData.thithi2);
        setThithiTime2(apiData.thithi2Time);
        setdurmuhurtham(apiData.durmuhurtham1);
        setdurmuhurtham2(apiData.durmuhurtham2);
        setrahukalam(apiData.rahukalam);
        setNakshtram(apiData.nakshtram1);
        setnakshtramtime(apiData.nakshtram1Time);
        setNakshtram2(apiData.nakshtram2);
        setnakshtramtime2(apiData.nakshtram2Time);
        setSamvatsar(apiData.samvatsar);
        setRitu(apiData.ritu);
        setMasa(apiData.masa);
        setPaksha(apiData.paksha);
        setAyanam(apiData.ayanam);
        setAyanamTime(apiData.ayanamtime);
      })
      .catch((err) => {
        console.log(err);
        toast.custom(
          <ErrorPopup
            showMessage={catchErrorMessageHandler(err)}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
      });
  }, [formatDate()]);

  useEffect(() => {
    apiRequest({
      basePath: `${CMS_BASE_URL}`,
      method: "GET",
      endpoint: "/wp-json/wp/v2/advertisement",
      includeToken: false,
    })
      .then((res) => {
        const acfList = res.data.map((item: any) => item.acf);
        if (acfList[0].enable[0] === "enable") {
          setMessageData(acfList);
          setShowMsg(true);
        } else {
          setMessageData([]);
          setShowMsg(false);
        }
        // setscroolMessageData(acfList);
        console.log(acfList[0].enable[0], "Acf List");
      })
      .catch((err) => {
        console.log(err);
        toast.custom(
          <ErrorPopup
            showMessage={catchErrorMessageHandler(err)}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
      });
  }, []);

  const getCurrentDateAndDay = () => {
return (
  <Typography className={styles.head}>
              Date<span className={styles.subHead}> : {formatDate()} {formatWeekday(new Date())}</span>
            </Typography>
)
  }

  return (
    <>
      <div className={styles.totalContainer}>
        <div className={styles.BoxContainer}>
          {getCurrentDateAndDay()}
          {!isEmpty(Samvatsar) && !isNil(Samvatsar) ? (
            <Typography className={styles.head}>
              Samvatsar<span className={styles.subHead}> : {Samvatsar}</span>
            </Typography>
          ) : (
            <></>
          )}
          {!isEmpty(ritu) && !isNil(ritu) ? (
            <Typography className={styles.head}>
              Ritu<span className={styles.subHead}> : {ritu}</span>
            </Typography>
          ) : (
            <></>
          )}
          {!isEmpty(masa) && !isNil(masa) ? (
            <Typography className={styles.head}>
              Masa<span className={styles.subHead}> : {masa}</span>
            </Typography>
          ) : (
            <></>
          )}
          {!isEmpty(paksha) && !isNil(paksha) ? (
            <Typography className={styles.head}>
              Paksha<span className={styles.subHead}> : {paksha}</span>
            </Typography>
          ) : (
            <></>
          )}

          {!isEmpty(thithi) && !isNil(thithi) && !isEmpty(thithiTime) ? (
            <CustomTooltip
              className={styles.arrowTooltip}
              title={
                !isEmpty(thithiTime) && !isNil(thithiTime) ? (
                  <Typography>
                    {" "}
                    <b>Thithi End Time </b>
                  </Typography>
                ) : (
                  ""
                )
              }
            >
              <Typography className={styles.head}>
                Thithi
                <span className={styles.subHead}>
                  {" "}
                  : {thithi} {thithiTime}
                </span>
              </Typography>
            </CustomTooltip>
          ) : (
            <></>
          )}
          {!isEmpty(thithi) && !isNil(thithi) && isNil(thithiTime) ? (
            <Typography className={styles.head}>
              Thithi
              <span className={styles.subHead}> : {thithi}</span>
            </Typography>
          ) : (
            <></>
          )}
          {!isEmpty(thithi2) && !isNil(thithi2) && !isNil(thithiTime2) ? (
            <CustomTooltip
              className={styles.arrowTooltip}
              title={
                !isEmpty(thithiTime2) && !isNil(thithiTime2) ? (
                  <Typography>
                    {" "}
                    <b>Thithi End Time </b>
                  </Typography>
                ) : (
                  ""
                )
              }
            >
              <Typography className={styles.head}>
                Thithi
                <span className={styles.subHead}>
                  {" "}
                  : {thithi2} {thithiTime2}
                </span>
              </Typography>
            </CustomTooltip>
          ) : (
            ""
          )}
          {!isEmpty(thithi2) && !isNil(thithi2) && isNil(thithiTime2) ? (
            <Typography className={styles.head}>
              Thithi
              <span className={styles.subHead}>
                {" "}
                : {thithi2} {thithiTime2}
              </span>
            </Typography>
          ) : (
            <></>
          )}

          {!isEmpty(ayanam) && !isNil(ayanam) && !isNil(ayanamTime) ? (
            <CustomTooltip
              title={
                <Typography>
                  {" "}
                  <b>End Time: Ayanam : </b>
                </Typography>
              }
            >
              <Typography className={styles.head}>
                Ayanam<span className={styles.subHead}> : {ayanam}</span>
              </Typography>
            </CustomTooltip>
          ) : (
            ""
          )}
          {!isEmpty(ayanam) && !isNil(ayanam) && isNil(ayanamTime) ? (
            <Typography className={styles.head}>
              Ayanam<span className={styles.subHead}> : {ayanam}</span>
            </Typography>
          ) : (
            <></>
          )}

          {!isEmpty(nakshtram) && !isNil(nakshtram) && !isNil(nakshtramTime) ? (
            <CustomTooltip
              title={
                !isEmpty(nakshtramTime) && !isNil(nakshtramTime) ? (
                  <Typography>
                    {" "}
                    <b>Nakshatram End Time</b>
                  </Typography>
                ) : (
                  ""
                )
              }
            >
              <Typography className={styles.head}>
                Nakshatram{" "}
                <span className={styles.subHead}>
                  {" "}
                  : {nakshtram} {nakshtramTime}
                </span>
              </Typography>
            </CustomTooltip>
          ) : (
            ""
          )}
          {!isEmpty(nakshtram) && !isNil(nakshtram) && isNil(nakshtramTime) ? (
            <Typography className={styles.head}>
              Nakshatram{" "}
              <span className={styles.subHead}>
                {" "}
                : {nakshtram} {nakshtramTime}
              </span>
            </Typography>
          ) : (
            <></>
          )}

          {!isEmpty(nakshtram2) &&
          !isNil(nakshtram2) &&
          !isNil(nakshtramTime2) ? (
            <CustomTooltip
              title={
                !isEmpty(nakshtramTime2) && !isNil(nakshtramTime2) ? (
                  <Typography>
                    {" "}
                    <b>Nakshtram End Time</b>
                  </Typography>
                ) : (
                  ""
                )
              }
            >
              <Typography className={styles.head}>
                Nakshatram{" "}
                <span className={styles.subHead}>
                  {" "}
                  : {nakshtram2} {nakshtramTime2}
                </span>
              </Typography>
            </CustomTooltip>
          ) : (
            ""
          )}
          {!isEmpty(nakshtram2) &&
          !isNil(nakshtram2) &&
          isNil(nakshtramTime2) ? (
            <Typography className={styles.head}>
              Nakshatram{" "}
              <span className={styles.subHead}>
                {" "}
                : {nakshtram2} {nakshtramTime2}
              </span>
            </Typography>
          ) : (
            <></>
          )}

          {!isEmpty(rahukalam) && !isNil(rahukalam) ? (
            <Typography className={styles.head}>
              Rahukalam <span className={styles.subHead}> : {rahukalam}</span>
            </Typography>
          ) : (
            <></>
          )}

          {!isEmpty(durmuhurtham) && !isNil(durmuhurtham) ? (
            <Typography className={styles.head}>
              Durmuhurtham{" "}
              <span className={styles.subHead}> : {durmuhurtham} </span>
            </Typography>
          ) : (
            <></>
          )}

          {!isEmpty(durmuhurtham2) && !isNil(durmuhurtham2) ? (
            <Typography className={styles.head}>
              Durmuhurtham{" "}
              <span className={styles.subHead}> : {durmuhurtham2} </span>
            </Typography>
          ) : (
            <></>
          )}
        </div>
      </div>
      <div className={styles.templeTimingsContainer}>
        <Typography className={styles.content}>
          Temple Open Hours:{" "}
          {breakEndTime && breakStartTime
            ? `${startTime} to ${breakStartTime} & ${breakEndTime} to ${endTime}`
            : `${startTime} to ${endTime}`}
        </Typography>
      </div>
      {/* <div className={styles.templeJobsContainer}> */}
      {showMsg ? <Grid item xs={12} md={12} className={styles.templeJobsContainer}>
          <div className={styles.messageTextContainer}>
            {messageData.map((eachItem: any, index: any) => (
              eachItem.advertise_text && (
                <div key={index} className={styles.headerContent}><span className={styles.scrollheader} dangerouslySetInnerHTML={{ __html: eachItem.advertise_text }} /></div>
              )
            ))}
          </div>
        </Grid> : ""}
      {/* </div> */}
    </>
  );
}
